/* eslint-disable camelcase */
export const project = 'ga4'; // need this for when we dynamically import utils

/**
 *
 * @param {Object} win - The window object. Contains the gtag function.
 * @param {Object} payload - The payload to send coming from mappings.
 *
 */

const getVehicle = (eventData, vehicles) =>
	vehicles.length === 1 ? vehicles[0] : eventData?.vehicle;

const getGIds = (ids) => ids.filter((id) => id.startsWith('G-'));

export const sending = ({ win, data: payload, preview, flags, event }) => {
	// Event Viewer
	const payloads = [];
	let googleAdwordsConversionIds;

	// flagged while we figure out direction of gtag ga4 reporting
	// may be refactoring to align with industry standards
	if (
		win.gtag &&
		typeof win.gtag === 'function' &&
		flags['ws-tagging-call-gtag']
	) {
		// PUSH TO GTAG (for clients)
		// ---------------------------
		// promise setup
		if (win?.DDC?.thirdPartyServices?.googleAdwordsConversion?.ids) {
			googleAdwordsConversionIds = Promise.resolve({
				gtags: getGIds(
					win?.DDC?.thirdPartyServices?.googleAdwordsConversion?.ids
				).toString()
			});
		} else {
			googleAdwordsConversionIds = new Promise((resolve) => {
				win.addEventListener('googleAdwordsConversionIdsReady', () => {
					resolve({
						gtags: getGIds(
							win?.DDC?.thirdPartyServices
								?.googleAdwordsConversion?.ids
						).toString()
					});
				});
			});
		}

		payloads.push(
			new Promise((resolve) => {
				googleAdwordsConversionIds.then(() => {
					// Google Ids from Google Adwords Conversion

					// we could also use the gtags from the resolved promise and split on the comma
					// but this works too
					const googleIds = getGIds(
						win?.DDC?.thirdPartyServices?.googleAdwordsConversion
							?.ids
					);
					if (!preview) {
						win.gtag('event', payload.event, {
							send_to: googleIds,
							...payload
						});
						resolve({
							data: payload,
							event,
							name: project,
							sender: 'gtag'
						});
					} else {
						// if in preview mode resolve which will set the payload to undefined
						resolve();
					}
					// PUSH measurement_ids
					win.asc_datalayer.measurement_ids.push(googleIds);
				});
			})
		);

		// ---------------------------
	}

	// PUSH events
	win.asc_datalayer.events.push(payload);

	payloads.push({
		data: payload,
		sender: 'asc_datalayer.events'
	});

	return {
		payloads,
		propsForNewRelic: googleAdwordsConversionIds
	};
};

export const getLanguage = ({ window }) =>
	window.DDC.dataLayer.page.attributes?.locale?.substring(0, 2);

export const getBrand = ({ window }) =>
	window.DDC.dataLayer.site.franchises.join('|');

export const getPrice = ({ eventData, vehicles = [] }) => {
	const vehicle = getVehicle(eventData, vehicles);
	let price;
	if (vehicle) {
		price =
			vehicle.newOrUsed === 'new' ? vehicle.msrp : vehicle.retailValue;
	}
	return price;
};

export const getCondition = ({ eventData, vehicles = [] }) => {
	const vehicle = getVehicle(eventData, vehicles);
	let condition;
	if (vehicle) {
		if (vehicle.newOrUsed === 'used') {
			condition = vehicle.certified === 'true' ? 'cpo' : 'used';
		} else if (vehicle.newOrUsed === 'new') {
			condition = 'new';
		}
	}
	return condition;
};

export const getVehicleItems = ({ vehicles }) => {
	const items = [];
	vehicles.forEach((vehicle) => {
		const item = {
			item_id: vehicle.vin || vehicle.uuid,
			item_number: vehicle.stockNumber,
			item_condition: getCondition({
				eventData: {
					vehicle
				}
			}),
			item_year: vehicle.modelYear,
			item_make: vehicle.make,
			item_model: vehicle.model,
			item_variant: vehicle.trim,
			item_color: vehicle.exteriorColor,
			item_type: vehicle.bodyStyle,
			item_fuel_type: vehicle.fuelType,
			item_inventory_date: vehicle.inventoryDate,
			price: getPrice({
				eventData: {
					vehicle
				}
			})
		};
		items.push(item);
	});
	return items;
};

export const getItemlistType = ({ window }) => {
	const pageAlias = window.DDC.dataLayer.page.pageInfo.pageName;
	const types = {
		_NEW: 'new',
		_USED: 'used',
		_CERTIFIED_USED: 'cpo',
		_ALL: 'all'
	};
	let type;
	Object.keys(types).forEach((key) => {
		type = pageAlias.indexOf(key) > -1 ? types[key] : type;
	});
	return type;
};

export const getFacetRange = ({ eventData }) => {
	return eventData.isSlider &&
		eventData.clickedFacetValue?.indexOf?.('-') > -1
		? `minmax_${eventData.clickedFacetName}`
		: '';
};
